<template>
  <a-modal
    title="权益详情"
    :visible="visible"
    :footer="null"
    @cancel="handleCancel"
    destroyOnClose
    width="500px"
  >
    <a-alert
      :message="`会员等级：${vipName}`"
      type="info"
      show-icon
      class="mb-16"
    />
    <a-table
      :columns="columns"
      :data-source="benefits"
      :pagination="false"
      :rowKey="record => record.benefit_tag_id"
      size="small"
    />
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      vipId: "",
      vipName: "",
      benefits: [],
      columns: [
        {
          title: "权益名称",
          dataIndex: "benefitTag.name",
          width: 200,
        },
        {
          title: "数量",
          dataIndex: "quantity",
          width: 100,
          align: "center",
        },
      ],
    };
  },
  methods: {
    init(vipId, vipName, benefits) {
      this.visible = true;
      this.vipId = vipId;
      this.vipName = vipName;
      console.log("权益详情数据:", benefits);
      this.benefits = benefits || [];
    },
    handleCancel() {
      this.visible = false;
      this.benefits = [];
    },
  },
};
</script>

<style scoped>
.mb-16 {
  margin-bottom: 16px;
}
</style>
